// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js"}[chunkId] + "-" + {"532":"52e8cbbdeb115bf23fc3","678":"a6dda08252965c419878"}[chunkId] + ".js";
};